import { initMobxEnv, initMobxRoot } from '@monorepo/client-common';
import RootStore from '../stores/root-store';
import { RootEnv } from './create-store';

export const getRoot = (): RootStore => initMobxRoot<RootStore>();
export const getEnv = (): RootEnv => initMobxEnv<RootEnv>();
